var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBsc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.333496,
    width: 32,
    height: 32,
    rx: 12,
    fill: "#F3BA2F",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2817 14.883L16.0006 12.1641L18.7209 14.8842L20.3029 13.3022L16.0006 9L11.6997 13.3009L13.2817 14.8829L13.2817 14.883ZM9 15.9991L10.5821 14.4168L12.1641 15.9988L10.582 17.5809L9 15.9991ZM16.0001 19.8363L13.2812 17.1175L11.697 18.6972L11.6993 18.6995L16.0001 23.0004L20.3024 18.6982L20.3032 18.6974L18.7203 17.1162L16.0001 19.8363ZM19.8354 16.001L21.4175 14.4189L22.9995 16.0009L21.4175 17.583L19.8354 16.001ZM16.0008 14.4189L14.4187 16.001L16.0007 17.583L17.5828 16.0009L16.0008 14.4189Z",
    fill: "#F3BA2F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBsc);
export default __webpack_public_path__ + "static/media/bsc.51ec964c62bf8810a1a106b05b8dbdc6.svg";
export { ForwardRef as ReactComponent };